export const CONSENT_API_ROUTES = {
  CONSENT: 'user/consent',
} as const;
